module.exports = __webpack_public_path__ + "static/media/notification-icon.dafc39a4.svg";